<template>
    <div class="flex flex-col justify-center items-center min-h-screen text-center px-8">
        <img src="@/assets/Next_logo.svg" class="mb-5">
        <h2 class="font-bold text-xl mb-3">La gestione dei progetti si è spostata sul nuovo Next-Yu</h2>
        <p class="mb-3">
            Questa sezione del vecchio gestionale è stata dismessa e non è più in uso.<br>
            Progetti e sottoprogetti si consultano e si gestiscono esclusivamente sul nuovo Next-Yu.
        </p>
        <a href="https://nextyu-qaprod.nextgroup.eu/progetti/sottoprogetti/" target="_blank" rel="noopener"
           class="bg-next-orange text-white font-bold px-4 py-2 mb-3">Vai ai progetti su Next-Yu</a>
        <router-link :to="{name:'Home'}" class="text-next-orange underline text-sm">Torna alla home</router-link>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name: 'ProgettiDismessi',
})
export default class ProgettiDismessi extends Vue {
}
</script>
